export const environment = {
  production: true,
  name: '(PROD)',
  APIEndpoint: 'https://agendamiento.revisionestecnicas.cl',
  microservices: {
    auth: '/api/ms-prt-auth/',
    booking: '/api/ms-prt-booking-availability/',
    rules: '/api/ms-prt-booking-rules/',
    prebooking: '/api/ms-prt-booking-checkout/',
    savebooking: '/api/ms-prt-booking/',
    plant: '/api/ms-prt-plant-manager/',
    searchBooking: '/api/ms-prt-booking/',
    changeBooking: '/api/ms-prt-booking/',
    sendMail: '/api/ms-prt-booking/',
    payments: '/api/ms-prt-tax-document/',
    typesInspection: '/api/ms-prt-technical-inspection/',
    webpay: '/api/ms-sgs-payment/',
    channel: '/booking/search-type'
  },
  username: 'SGS',
  password: 'SGS',
  recaptcha: {
    siteKey: '6Lc5mjQjAAAAAMzqtnh30LwR4qLz49ysZw4uDIhI',
  }
};
